module.exports = __webpack_public_path__ + "static/media/icn_satisfied_clients.e3af60f7.svg";